import { render, staticRenderFns } from "./TableDialogs.vue?vue&type=template&id=988ba460&"
import script from "./TableDialogs.vue?vue&type=script&lang=js&"
export * from "./TableDialogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports